import { Link } from "react-router-dom";
import { prof_routes } from "../../../router/all_routes";
import { useAcademicYear } from "../../../../core/common/context/AcademicYearContext";
import EDTTooltipOption from "./tooltipOption";
import { useEffect, useState } from "react";
import { getAllPublishedEDTTeacherByYear } from "../../../../api/edt";
import { toast } from "sonner";
import {
  getBreaksByYear,
  getSessionsByYear,
  getSettingByYear,
} from "../../../../api/settingEDT";
import {
  Action,
  buildPermissionContext,
  Resource,
} from "../../../../core/common/autorisations/permissionsMap";
import { toMinutes } from "../../../../helper/toMinutes";
import AbsenceCourseModal from "../course/absenceCourseModal";
import SuivisCourseModal from "../course/suivisCourseModal";
import { getAbsenceByClass } from "../../../../api/etudiants";
import { getLateByClass } from "../../../../api/late";
import { getTrackingByCourse } from "../../../../api/cours";
import TeacherEDTGrid from "./TeacherEDTGrid";
import { useSelector } from "react-redux";

const TeacherEDT = () => {
  const routes = prof_routes;
  const teacherData = useSelector((state: any) => state.auth.user);

  const { selectedYear } = useAcademicYear();
  const [timetables, setTimeTables] = useState<any[]>([]);
  const [days, setDays] = useState<any[]>([]);
  const [sessions, setSessions] = useState<any[]>([]);
  const [allBreaks, setAllBreaks] = useState<any[]>([]);
  const [courses, setCourses] = useState<any>();
  const [selectedTimetable, setSelectedTimetable] = useState(timetables[0]);
  const [absenceOpen, setAbsenceOpen] = useState(false);
  const [followOpen, setFollowOpen] = useState(false);
  const [selectedCourseVersionIds, setSelectedCourseVersionIds] = useState<
    any[]
  >([]);
  const [selectedCourseClasses, setSelectedCourseClasses] = useState<any[]>([]);
  const [selectedCourseSessions, setSelectedCourseSessions] = useState<any[]>(
    [],
  );

  const prefetchCourseFlags = async (data: any) => {
    const updated: any = JSON.parse(JSON.stringify(data));
    const dayKeys = Object.keys(updated || {});
    for (const day of dayKeys) {
      const sessionKeys = Object.keys(updated[day] || {});
      for (const sid of sessionKeys) {
        const list = updated[day][sid] || [];
        for (let i = 0; i < list.length; i++) {
          const course = list[i];
          let hasTracking = false;
          let hasAbsenceOrLate = false;
          try {
            const tr = await getTrackingByCourse(course.courseVersionIds?.[0]);
            const trData = tr?.data || [];
            const selected = trData.filter((t: any) =>
              course.courseVersionIds?.includes(t?.id_coursVersionEDT),
            );
            hasTracking = selected.length > 0;
          } catch (error: any) {
            // console.log("erreur de chargement des suivis : ", error);
            toast.error(
              error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                "Une erreur s'est produit, Réessayer plus tard",
            );
          }
          try {
            for (const cls of course.classes || []) {
              const abs = await getAbsenceByClass(
                cls.id,
                course.courseVersionIds?.[0],
                buildPermissionContext(Resource.STUDENT_ABSENCE, Action.READ),
              );
              const lates = await getLateByClass(
                cls.id,
                course.courseVersionIds?.[0],
                buildPermissionContext(Resource.STUDENT_LATE, Action.READ),
              );
              if (
                (abs?.data || []).length > 0 ||
                (lates?.data || []).length > 0
              ) {
                hasAbsenceOrLate = true;
                break;
              }
            }
          } catch (error: any) {
            // console.log("erreur de chargement des absences et retards : ", error);
            toast.error(
              error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                "Une erreur s'est produit, Réessayer plus tard",
            );
          }
          updated[day][sid][i].hasTracking = hasTracking;
          updated[day][sid][i].hasAbsenceOrLate = hasAbsenceOrLate;
        }
      }
    }
    setCourses(updated);
  };

  const fecthAllEdts = async () => {
    try {
      if (!selectedYear?.id) return;
      const response = await getAllPublishedEDTTeacherByYear(
        selectedYear?.id,
        teacherData?.id,
      );
      setTimeTables(response.data || []);
    } catch (error: any) {
      // console.log("erreur de chargement des EDTs : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
      setTimeTables([]);
    }
  };

  const fetchWorkingDays = async () => {
    try {
      if (!selectedYear?.id) return;
      const response = await getSettingByYear(
        selectedYear.id,
        buildPermissionContext(Resource.EDT, Action.READ),
      );
      const rawDays: string = response.data[0].working_days;
      const cleanedDays = rawDays.replace(/[{}]/g, "");
      const daysArray = cleanedDays
        .split(",")
        .map((d) => d.replace(/"/g, "").trim());
      const weekOrder = [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche",
      ];
      const sortedDays = daysArray.sort(
        (a, b) => weekOrder.indexOf(a) - weekOrder.indexOf(b),
      );
      setDays(
        sortedDays.map((day: any, idx: number) => ({
          id: `d${idx + 1}`,
          name: day,
        })),
      );
    } catch (error: any) {
      // console.log("erreur de chargement des jours ouvrables : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const fetchEDTBreaksByYear = async () => {
    try {
      if (!selectedYear) return;
      const response = await getBreaksByYear(
        selectedYear?.id,
        buildPermissionContext(Resource.SETTING_EDT, Action.READ),
      );
      setAllBreaks(
        response.data.map((breakItem: any) => ({
          id: breakItem.id,
          label: breakItem.name,
          start: breakItem.start_time?.slice(0, 5),
          end: breakItem.end_time?.slice(0, 5),
        })),
      );
    } catch (error: any) {
      // console.log("erreur lors de la récupération des pauses : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const fetchAllSessions = async () => {
    try {
      if (!selectedYear?.id) return;
      const response = await getSessionsByYear(selectedYear?.id);
      setSessions(
        response.data.map((session: any, index: number) => ({
          label: session.name,
          start_time: session.start_time?.slice(0, 5),
          end_time: session.end_time?.slice(0, 5),
          time: `${session.start_time?.slice(0, 5)} - ${session.end_time?.slice(0, 5)}`,
          index: index + 1,
          id: session.id,
          duration:
            toMinutes(session.end_time?.slice(0, 5)) -
            toMinutes(session.start_time?.slice(0, 5)),
        })),
      );
    } catch (error: any) {
      // console.log("erreur de chargement des séances : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const formattedCourses = () => {
    if (
      !selectedTimetable?.versionedts ||
      selectedTimetable.versionedts.length === 0
    )
      return {};
    const version = selectedTimetable.versionedts[0];
    if (!version.CourseVersionEDTs) return setCourses(undefined);

    const coursesData: any = {};
    const groupedBySessionTime: { [key: string]: any[] } = {};

    version.CourseVersionEDTs.forEach((courseVersion: any) => {
      const key = `${courseVersion.day_course}_${courseVersion.SessionStart?.id}_${courseVersion.SessionEnd?.id}`;
      if (!groupedBySessionTime[key]) groupedBySessionTime[key] = [];
      groupedBySessionTime[key].push(courseVersion);
    });

    Object.entries(groupedBySessionTime).forEach(([_key, coursesInSlot]) => {
      const uniqueCourses: { [courseKey: string]: any } = {};
      coursesInSlot.forEach((courseVersion: any) => {
        const courseId = courseVersion.CourseClass?.Course?.id;
        const subjectLabel =
          courseVersion.CourseClass?.Course?.Subject?.label ||
          "Matière inconnue";
        const courseKey = `${courseId}_${subjectLabel}`;
        if (!uniqueCourses[courseKey]) {
          uniqueCourses[courseKey] = {
            name: subjectLabel,
            id: courseVersion?.course_version_id || courseId,
            room: courseVersion.Classroom?.label || "Salle inconnue",
            teacherId: courseVersion.CourseClass?.Course?.TeacherProfil?.id,
            teacher:
              `${courseVersion.CourseClass?.Course?.TeacherProfil?.firstname || ""} ${courseVersion.CourseClass?.Course?.TeacherProfil?.lastname || ""}`.trim(),
            classes: [],
            courseVersionIds: [],
            sessionStart: courseVersion.SessionStart,
            sessionEnd: courseVersion.SessionEnd,
            state_course: courseVersion.state_course,
            type_course: courseVersion.type_course,
            date_course: courseVersion.date_course,
            classroom: courseVersion.Classroom,
          };
        }
        const classLabel = courseVersion.CourseClass?.Class
          ? `${courseVersion.CourseClass.Class.Level?.abbreviation || ""}-${courseVersion.CourseClass.Class.abbreviation || ""}`.trim()
          : "Classe inconnue";
        if (
          !uniqueCourses[courseKey].classes.some(
            (c: any) => c.id === courseVersion.CourseClass?.Class?.id,
          )
        ) {
          uniqueCourses[courseKey].classes.push({
            id: courseVersion.CourseClass?.Class?.id,
            label: classLabel,
            fullLabel:
              courseVersion.CourseClass?.Class?.label || "Classe inconnue",
          });
        }
        if (
          !uniqueCourses[courseKey].courseVersionIds.some(
            (c: any) => c === courseVersion?.course_version_id,
          )
        ) {
          uniqueCourses[courseKey].courseVersionIds.push(
            courseVersion?.course_version_id || "",
          );
        }
      });

      const firstCourse = coursesInSlot[0];
      const day = firstCourse.day_course;
      const sessionId = firstCourse.SessionStart?.id;
      if (!coursesData[day]) coursesData[day] = {};
      Object.entries(uniqueCourses).forEach(([_, course]: [string, any]) => {
        if (!coursesData[day][sessionId]) coursesData[day][sessionId] = [];
        coursesData[day][sessionId].push(course);
      });
    });

    setCourses(coursesData);
    prefetchCourseFlags(coursesData);
  };

  useEffect(() => {
    fecthAllEdts();
    fetchWorkingDays();
    fetchAllSessions();
    fetchEDTBreaksByYear();
  }, [selectedYear]);

  useEffect(() => {
    formattedCourses();
  }, [selectedTimetable, sessions]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="student-edt-page-header">
            <div className="student-edt-title-block">
              <h3 className="page-title mb-1">Emploi du Temps</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.teacherDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    EDT
                  </li>
                </ol>
              </nav>
            </div>
            <div className="student-edt-toolbar">
              <EDTTooltipOption
                timetables={timetables}
                onChange={(t) => setSelectedTimetable(t)}
              />
            </div>
          </div>
          {/* /Page Header */}

          <div className="card student-edt-card">
            {/* En-tête sticky */}
            <div className="student-edt-card-header">
              <h5 className="mb-0 student-edt-date-range">
                {selectedTimetable
                  ? `Du ${new Date(selectedTimetable?.valid_from).toLocaleDateString("fr-FR")} au ${new Date(selectedTimetable?.valid_until).toLocaleDateString("fr-FR")}`
                  : "Sélectionner un emploi du temps"}
              </h5>
            </div>

            {/* Grille */}
            <div className="card-body pb-0 student-edt-body">
              {courses && Object.keys(courses).length > 0 ? (
                <TeacherEDTGrid
                  days={days}
                  sessions={sessions}
                  courses={courses}
                  onOpenAbsences={({ courseVersionIds, classes, sessions }) => {
                    setSelectedCourseVersionIds(courseVersionIds || []);
                    setSelectedCourseClasses(classes || []);
                    setSelectedCourseSessions(sessions || []);
                    setAbsenceOpen(true);
                  }}
                  onOpenSuivi={({ courseVersionIds }) => {
                    setSelectedCourseVersionIds(courseVersionIds || []);
                    setFollowOpen(true);
                  }}
                />
              ) : (
                <div className="student-edt-empty">
                  <i className="ti ti-calendar-off student-edt-empty-icon" />
                  <p>Aucun cours prévus.</p>
                </div>
              )}
            </div>

            {allBreaks.length > 0 && (
              <div className="card-footer border-0 pt-2 pb-3">
                <p className="text-muted small mb-2 fw-semibold">Pauses :</p>
                <div className="row g-2">
                  {allBreaks.map((brk: any) => (
                    <div
                      key={brk.id}
                      className="col-12 col-sm-6 col-lg-4 col-xxl-3 d-flex"
                    >
                      <div className="card flex-fill mb-0">
                        <div className="card-body py-2 px-3">
                          <span className="bg-info badge badge-sm mb-1">
                            {brk?.label}
                          </span>
                          <p className="text-dark mb-0 small">
                            <i className="ti ti-clock me-1" />
                            {brk?.start} à {brk?.end}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .student-edt-page-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 16px;
        }
        .student-edt-title-block { flex: 1 1 auto; min-width: 0; }
        .student-edt-toolbar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
        .student-edt-card { display: flex; flex-direction: column; overflow: hidden; }
        .student-edt-card-header {
          position: sticky;
          top: 0;
          left: 0;
          z-index: 200;
          background: #fff;
          padding: 12px 20px;
          border-bottom: 1px solid #e8eaf0;
          display: flex;
          align-items: center;
        }
        .student-edt-date-range { font-size: 15px; font-weight: 600; color: #2c3e8c; }
        .student-edt-body { padding-top: 8px; overflow: hidden; }
        .student-edt-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 48px 24px;
          color: #9098b1;
          gap: 12px;
        }
        .student-edt-empty-icon { font-size: 48px; opacity: 0.4; }
        @media (max-width: 575.98px) {
          .student-edt-page-header { flex-direction: column; align-items: flex-start; }
          .student-edt-toolbar { width: 100%; }
          .student-edt-card-header { padding: 10px 14px; }
          .student-edt-date-range { font-size: 13px; }
        }
      `}</style>

      <AbsenceCourseModal
        visible={absenceOpen}
        idsCourseVersionEDT={selectedCourseVersionIds}
        sessions={selectedCourseSessions}
        idsClass={selectedCourseClasses}
        onCancel={() => setAbsenceOpen(false)}
      />
      <SuivisCourseModal
        visible={followOpen}
        idsCourseVersionEDT={selectedCourseVersionIds}
        onCancel={() => setFollowOpen(false)}
        onSave={() => setFollowOpen(false)}
      />
    </>
  );
};

export default TeacherEDT;
